import { render, staticRenderFns } from "./setCoorSchedForCourse.vue?vue&type=template&id=063be82a&"
import script from "./setCoorSchedForCourse.vue?vue&type=script&lang=js&"
export * from "./setCoorSchedForCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports